module.exports = __webpack_public_path__ + "img/music-library-2.f55e9702.svg";